/**
 * Le code nu d'un article, extrait de ce qu'un champ à liste (`datalist`) écrit dans la saisie.
 *
 * ## Le défaut que ceci corrige *(signalé par Chris le 26/08/2026 : « si je sélectionne un
 * article et que je clique sur ajouter cela ne fonctionne pas »)*
 *
 * Les propositions du champ article portent `value={`${code} — ${description}`}`, pour que la
 * saisie reste lisible après le choix. Choisir une proposition écrit donc ce texte entier dans
 * le champ — et ce texte repartait aussitôt comme terme de recherche. Le serveur cherche
 * `code ILIKE '%…%' OR description ILIKE '%…%'` : la chaîne complète ne ressemble ni à l'un ni
 * à l'autre, **il ne trouvait rien, et la liste se vidait**. Or c'était la liste qui servait à
 * retrouver le code derrière le libellé. Le formulaire envoyait alors
 * `« 1002178 — GEOTEXTILE… »` comme code, et le serveur répondait, à juste titre, que cet
 * article était inconnu.
 *
 * Le défaut était donc une **dépendance à un état qui disparaît**. Lire le code dans le texte
 * lui-même ne dépend de rien.
 *
 * ## Le séparateur est le tiret CADRATIN entouré d'espaces, jamais le trait d'union
 *
 * C'est le point à ne pas se tromper : les codes de la grille tarifaire s'écrivent
 * `03-01-01-010`. Couper au premier `-` rendrait `03`. On coupe donc au premier ` — `, qui
 * n'apparaît dans aucun code.
 *
 * Une saisie sans séparateur — un code tapé à la main, ou un navigateur qui n'écrit que le
 * `value` — ressort telle quelle : il n'y a rien à retirer.
 */
const SEPARATEUR = " — ";

export function codeDuChampArticle(saisie: string): string {
  const texte = saisie.trim();
  const coupe = texte.indexOf(SEPARATEUR);
  return coupe === -1 ? texte : texte.slice(0, coupe).trim();
}
